import { TableSearchColumn } from "../types/table-column";

export const casesSearchColumns: TableSearchColumn[] = [
  { label: "STAGES", searchId: "stageId" },
  { label: "AFFECTED_COMPANY", searchId: "branchId" },
  { label: "RISK_LEVELS", searchId: "riskLevelId" },
  { label: "ROLE", searchId: "role" },
  // { label: "period", searchId: "period" },
  // { label: "clerk", searchId: "assigneeId" },
];

export const CasesFilterStags = [
  {
    key: 1,
    name: "NEW",
  },
  {
    key: 2,
    name: "IN_PROGRESS",
  },
  // {
  //   key: 3,
  //   name: "PUBLISHED",
  // },
];

export const CasesFilterRiskLevels = [
  {
    key: 1,
    name: "HIGH_RISK",
  },
  {
    key: 2,
    name: "MIDDLE_RISK",
  },
  {
    key: 3,
    name: "NO_RISK",
  },
];
